import { render } from "./AIcon.vue?vue&type=template&id=72609ec4"
import script from "./AIcon.vue?vue&type=script&lang=js"
export * from "./AIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__